import { PersonalDocumentType } from '@gov-nx/core/types';

export const toPersonalDocumentType = (type?: string) => {
	if (type === 'ID') {
		return PersonalDocumentType.IDCard;
	}
	return PersonalDocumentType.passport;
};
